import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import { useI18n } from '@shell/composables/useI18n';
import { copyTextToClipboard } from '@shell/utils/clipboard';
import { ref } from 'vue';
import { useStore } from 'vuex';

export interface Props {
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CopyToClipboard',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = useI18n(store);
const copied = ref(false);
const timeout = ref<null | ReturnType<typeof setTimeout>>(null);

const onClick = (ev: MouseEvent) => {
  ev.stopPropagation();

  copyTextToClipboard(props.value);
  copied.value = true;

  if (timeout.value) {
    return;
  }

  timeout.value = setTimeout(() => {
    copied.value = false;
    timeout.value = null;
  }, 2000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["copy-to-clipboard", {copied: copied.value}]),
    "aria-label": _unref(i18n).t('component.resource.detail.copyToClipboard.ariaLabel.copy'),
    onClick: onClick
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("i", { class: "icon icon-copy" }, null, -1)
  ]), 10, _hoisted_1))
}
}

})